import CNRActivity from "./CNRActivity";
export default CNRActivity; 